export var ConfigFormUpdateAction;
(function (ConfigFormUpdateAction) {
    ConfigFormUpdateAction["DELETE_CRITERIA"] = "DELETE_CRITERIA";
    ConfigFormUpdateAction["ADD_NEW_CONDITION"] = "ADD_NEW_CONDITION";
    ConfigFormUpdateAction["DELETE_CONDITION"] = "DELETE_CONDITION";
    ConfigFormUpdateAction["UPDATE_DATA"] = "UPDATE_DATA";
})(ConfigFormUpdateAction || (ConfigFormUpdateAction = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["PEAKD"] = "PEAKD";
})(NotificationType || (NotificationType = {}));
